import { createSlice } from "@reduxjs/toolkit";

const fetchNotiSlice = createSlice({
  name: "refreshNoti",
  initialState: { refreshNoti: false },
  reducers: {
    toggleRefreshNoti: state => {
      state.refreshNoti = !state.refreshNoti;
    },
    setRefreshNoti: (state, action) => {
      state.refreshNoti = action.payload;
    },
  },
});

export const { toggleRefreshNoti, setRefreshNoti } = fetchNotiSlice.actions;
export default fetchNotiSlice.reducer;
